import axios from "../configurations/axios";
import { useAuth } from "../configurations/auth";
import { getEnvVariable } from "../utils/env-variable-helper";
import { clearBrowserStorage } from "../utils/browser-storage-helper";
import LoggedInUserInfoResponse from "../responses/LoggedInUserInfoResponse";

class AuthenticationService {
  async getLoggedInUserInfo() : Promise<LoggedInUserInfoResponse>{
    const response= await axios.get<LoggedInUserInfoResponse>("/api/authentication");
    console.log(response);
    return response.data;
  }

  async login() {
    try {
      const clientId = getEnvVariable("VUE_APP_AZURE_AUTH_CLIENT_ID");
      const auth = useAuth();
      await auth.msalInstance.initialize();

        const interactionStatusKey = "msal.interaction.status";
      if (window.sessionStorage.getItem(interactionStatusKey)) {
        window.sessionStorage.removeItem(interactionStatusKey);
      }

      await auth.msalInstance.loginRedirect({
        scopes: [`api://${clientId}/wsp-admin-api`],
      });
    } catch (error) {
      if (error instanceof Error) {
        throw new Error("There was an error logging in: " + error.message);
      }
    }
  }

  async handleRedirect() {
    try {
      const auth = useAuth();
      await auth.msalInstance.initialize();
      const response = await auth.msalInstance
        .handleRedirectPromise()
        .then((response) => {
          return response;
        });

      if (response) {
        const token = response.accessToken;
        const account = response.account;      
        if (account) {
          auth.msalInstance.setActiveAccount(account);
          auth.account = account;
            auth.token = token;

            await this.setToken(token);
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(
          "There was an error handling the redirect: " + error.message
        );
      }
    }
  }

    async logout() {
    await axios.post("/api/authentication/logout");
    const auth = useAuth();
    auth.account = null;
    auth.token = null;
    await auth.msalInstance.initialize();
    await auth.msalInstance.logoutRedirect();
    clearBrowserStorage();
  }

  async isAuthenticated() {
    const response = await axios.get(
      "/api/authentication/validate-authentication"
      );
      return response.data;
  }

    async setToken(token: string) {
        const response = await axios.post("/api/authentication/set-token", {
            token,
        });
        return response.data;
    }
}

export default new AuthenticationService();
